import { useState } from "react";

const benefits = [
  { icon: "ri-group-line", title: "同好圈子不冷场", desc: "18万+瓜友随时在线，任何时段发言都有人接，孤单？不存在。" },
  { icon: "ri-chat-1-line", title: "话题天天有料", desc: "影视、综艺、音乐、游戏等八大栏目每日更新，永远有聊不完的话题。" },
  { icon: "ri-vip-crown-2-line", title: "想聊就开新帖", desc: "没有固定台本，你的每次分享都可能成为下一个热门瓜料。" },
];

const rules = [
  "友善发言，就事论事，不搞人身攻击",
  "内容以事实为基础，拒绝造谣与传谣",
  "尊重不同观点，理性表达与讨论",
  "不刷屏、不恶意引战，维护整洁版面",
];

export default function Join() {
  const [joined, setJoined] = useState(false);

  return (
    <section id="join" className="scroll-mt-20 py-14">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="overflow-hidden rounded-[2rem] bg-gradient-to-br from-foreground-900 to-foreground-950 p-8 text-background-50 md:p-12">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            {/* 左：收益 */}
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 px-4 py-1.5 text-sm text-background-50">
                <i className="ri-vip-crown-2-line text-secondary-300" /> 为什么加入我们
              </span>
              <h2 className="mt-5 font-display text-3xl leading-snug text-background-50 md:text-4xl">
                一起吃瓜，<br />一起吃出归属感
              </h2>
              <div className="mt-7 space-y-4">
                {benefits.map((b, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-background-50/10 text-xl text-secondary-300">
                      <i className={b.icon} />
                    </span>
                    <div>
                      <h3 className="text-base font-bold text-background-50">{b.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-background-50/70">{b.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 右：公约 + CTA */}
            <div className="flex flex-col justify-between rounded-3xl bg-background-50/5 p-6 md:p-8">
              <div>
                <h3 className="flex items-center gap-2 font-display text-xl text-background-50">
                  <i className="ri-shield-check-line text-secondary-300" /> 瓜友公约
                </h3>
                <ul className="mt-5 space-y-3">
                  {rules.map((r, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm text-background-50/85">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500/30 text-accent-300">
                        <i className="ri-check-line text-xs" />
                      </span>
                      {r}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-8 rounded-2xl bg-background-50/10 p-5">
                {joined ? (
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500/30 text-accent-300">
                      <i className="ri-check-double-line text-xl" />
                    </span>
                    <div>
                      <p className="text-base font-bold text-background-50">欢迎入伙！</p>
                      <p className="text-sm text-background-50/70">你已是吃瓜同好会的一员，去挑个话题聊聊吧。</p>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                    <input
                      type="text"
                      placeholder="给自己起个瓜友昵称"
                      className="flex-1 rounded-full border border-background-50/20 bg-background-50/10 px-5 py-3 text-sm text-background-50 placeholder:text-background-50/50 focus:border-secondary-300 focus:outline-none"
                    />
                    <button
                      onClick={() => setJoined(true)}
                      className="rounded-full bg-secondary-400 px-6 py-3 text-sm font-bold text-foreground-900 transition hover:bg-secondary-300 whitespace-nowrap"
                    >
                      一键加入
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}